import { FC } from 'react';

import Section from 'molecules/Section';
import { splitSectionProps } from 'molecules/Section/config';

import ScrollFadeSection from 'components/Animations/ScrollFadeSection';
import MobileTable from 'components/Tables/PricingV2/components/MobileTable';
import TableAccordion from 'components/Tables/PricingV2/components/TableAccordion';
import TableHeading from 'components/Tables/PricingV2/components/TableHeading';
import { PricingTableConfigProps } from 'components/Tables/PricingV2/config';

const PricingTable: FC<PricingTableConfigProps> = props => {
  const {
    sectionProps,
    rest: { tableHeading, tableSections, ...details },
  } = splitSectionProps(props);

  return (
    <Section {...sectionProps}>
      <ScrollFadeSection delay={0.1}>
        <div className="hidden flex-col gap-6 rounded-xl border border-primary-300/30 bg-pricingTableGradient p-6 backdrop-blur-md lg:flex">
          <TableHeading tableHeading={tableHeading} {...details} />
          <TableAccordion
            tableSections={tableSections}
            tierOneTitle={details.tierOneTitle}
            tierTwoTitle={details.tierTwoTitle}
            tierThreeTitle={details.tierThreeTitle}
          />
        </div>
        <MobileTable {...details} tableSections={tableSections} />
      </ScrollFadeSection>
    </Section>
  );
};

export default PricingTable;
